<fin-purchase-review
  [cartOrOrder$]="cartOrOrder$"
  [cartOrOrderStatus$]="cartOrOrderStatus$"
  (ready)="proceedToPayment()"
  (edit)="setActive($event)"
  class="col-f md-col-3-10"
></fin-purchase-review>
